
    <app-button class="header-button" [text]="actionText" (onClick)="editSelectAction()" [disabled]="disabled"></app-button>
  